export enum ETipoBanner {
    PaginaPrincipal = 1,
    Ofertas = 2,
    Destaques = 3,
    Busca = 4,
    Categorias = 5,
}
